/**
 * CollabV3AvatarStack 컴포넌트
 * @description 겹친 얼굴 세 개 — 참여자 줄과 모금 카드의 낸 사람 줄이 함께 쓴다(앱과 같은 3개).
 * @example <CollabV3AvatarStack people={detail.participants} />
 */
import { memo } from "react";

import CollabV3Avatar from "./CollabV3Avatar";
import { collabV3DetailStyles } from "./CollabV3Detail.styles";
import type { CollabV3AvatarStackProps } from "./CollabV3Detail.types";

const AVATAR_COUNT = 3;

const CollabV3AvatarStack = memo<CollabV3AvatarStackProps>(({ people }) => {
  const styles = collabV3DetailStyles.participants;
  if (people.length === 0) return null;
  return (
    <span aria-hidden className={styles.stack}>
      {people.slice(0, AVATAR_COUNT).map((person) => (
        <span key={person.userId} className={styles.stackItem}>
          <CollabV3Avatar person={person} size="xs" />
        </span>
      ))}
    </span>
  );
});

CollabV3AvatarStack.displayName = "CollabV3AvatarStack";

export default CollabV3AvatarStack;
